import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type MergeDockMutationVariables = Types.Exact<{
  input: Types.MergeDockInput;
}>;


export type MergeDockMutation = { __typename?: 'Mutation', mergeLogisticsDock: { __typename?: 'LogisticsDockPayload', dock?: { __typename?: 'LogisticsDockStateData', tenantId: string, dockId: string, name: string, isActive: boolean, loadsPerDay?: number | null, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteDockMutationVariables = Types.Exact<{
  input: Types.DeleteDockInput;
}>;


export type DeleteDockMutation = { __typename?: 'Mutation', deleteLogisticsDock: { __typename?: 'LogisticsDockPayload', dock?: { __typename?: 'LogisticsDockStateData', tenantId: string, dockId: string, name: string, isActive: boolean, loadsPerDay?: number | null, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type LogisticsDockStateFieldsFragment = { __typename?: 'LogisticsDockStateData', tenantId: string, dockId: string, name: string, isActive: boolean, loadsPerDay?: number | null, updatedAt: Types.TDateISO, updatedBy: string };

export const LogisticsDockStateFieldsFragmentDoc = new TypedDocumentString(`
    fragment LogisticsDockStateFields on LogisticsDockStateData {
  tenantId
  dockId
  name
  isActive
  loadsPerDay
  updatedAt
  updatedBy
}
    `, {"fragmentName":"LogisticsDockStateFields"});
export const MergeDockDocument = new TypedDocumentString(`
    mutation MergeDock($input: MergeDockInput!) {
  mergeLogisticsDock(input: $input) {
    dock {
      ...LogisticsDockStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsDockStateFields on LogisticsDockStateData {
  tenantId
  dockId
  name
  isActive
  loadsPerDay
  updatedAt
  updatedBy
}`);
export const DeleteDockDocument = new TypedDocumentString(`
    mutation DeleteDock($input: DeleteDockInput!) {
  deleteLogisticsDock(input: $input) {
    dock {
      ...LogisticsDockStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsDockStateFields on LogisticsDockStateData {
  tenantId
  dockId
  name
  isActive
  loadsPerDay
  updatedAt
  updatedBy
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    MergeDock: build.mutation<MergeDockMutation, MergeDockMutationVariables>({
      query: (variables) => ({ document: MergeDockDocument, variables })
    }),
    DeleteDock: build.mutation<DeleteDockMutation, DeleteDockMutationVariables>({
      query: (variables) => ({ document: DeleteDockDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useMergeDockMutation, useDeleteDockMutation } = injectedRtkApi;
